// import React, { useState } from 'react';
// import { Navbar, Nav, NavDropdown, Container } from 'react-bootstrap';



// const Header = () => {
//   const [isNavOpen, setIsNavOpen] = useState(false);
//   const [isSearchOpen] = useState(false);


//   const toggleNav = () => {
//     setIsNavOpen(!isNavOpen);
//   };


//   return (
//     <header className>
//       {/* Header Top */}
//       <div className="header-top bgg-darkk pt-md-2">
//         <div className="container">
//           <div className="row justify-content-center justify-content-xl-between align-items-center">
//             <div className="col-auto">
//               <div className="header-top-contact">
//                 <ul className='anchor d-md-flex'>
//                   <li className='px-md-5 fw-bold'>
//                     <a className='text-white' href="tel:+919136271336">
//                       <i className="fas fa-phone-volume text-white"></i> +91 9136271336
//                     </a>
//                   </li>
                   
//                   <li>
//                     <a className='text-white' href="mailto:  booking@velocitycabs.com">
//                       <i className="far fa-envelope text-white"></i>
//                       <span className='text-white fw-bold'>   booking@velocitycabs.com</span>
//                     </a>
//                   </li>
//                 </ul>
//               </div>
//             </div>

//           </div>
//         </div>
//       </div>

//       {/* Main Navigation */}
//       <div className="main-navigation">
//         <Navbar expand="lg">
//           <Container>
//             <img src="/images/logo.jpg" className='logoo' alt="logo" />
//             <Navbar.Toggle aria-controls="main_nav" onClick={toggleNav}>
//               <i className="fas fa-bars darkcolorr"></i> 
//             </Navbar.Toggle>

//             <Navbar.Collapse id="main_nav" className={isNavOpen ? "show" : ""}>
//               <Nav className="mx-auto">
//                 <Nav.Link href="/" className='fw-bold nav-item'>Home</Nav.Link>
//                 <NavDropdown title="About Us" id="about-us-dropdown" className='fw-bold'>
//                   <NavDropdown.Item href="/about-us" className='fw-bold nav-item'>About Us</NavDropdown.Item>
//                   <NavDropdown.Item href="/term-condition" className='fw-bold nav-item'>Term & Condition</NavDropdown.Item>
//                   <NavDropdown.Item href="/privacy-policy" className='fw-bold '>Privacy Policy</NavDropdown.Item>
                 
//                 </NavDropdown>
//                 <Nav.Link href="/services" className='fw-bold nav-item'>Services</Nav.Link>
//                 <Nav.Link href="/our-fleet" className='fw-bold nav-item'>Our Fleet</Nav.Link>
//                 <Nav.Link href="/packages" className='fw-bold nav-item'>Packages</Nav.Link>
//                 <Nav.Link href="/booking" className='fw-bold nav-item'>Online Booking</Nav.Link>
//                 <Nav.Link href="/gallery" className='fw-bold nav-item'>Gallery</Nav.Link>
//                 <NavDropdown title="Contact Us" id="contact-dropdown" className='fw-bold'>
//                   <NavDropdown.Item href="/contact-us" className='fw-bold nav-item'>Contact Us</NavDropdown.Item>
//                   <NavDropdown.Item href="/enquiry" className='fw-bold'>Enquiry</NavDropdown.Item>
//                 </NavDropdown>
//               </Nav>
           
//             </Navbar.Collapse>
            
//           </Container>
         
//         </Navbar>
//       </div>

//       {/* Search Area */}
//       {isSearchOpen && (
//         <div className="search-area">
//           <form action="#">
//             <div className="form-group">
//               <input type="text" className="form-control" placeholder="Type Keyword..." />
//               <button type="submit" className="search-icon-btn">
//                 <i className="far fa-search"></i>
//               </button>
//             </div>
//           </form>
//         </div>
//       )}
//     </header>
//   );
// };

// export default Header;



// import React, { useState } from 'react';
// import { Navbar, Nav, NavDropdown, Container } from 'react-bootstrap';
// import { Link } from 'react-router-dom';

// const Header = () => {
//   const [isNavOpen, setIsNavOpen] = useState(false);
//   const [isSearchOpen] = useState(false);

//   const toggleNav = () => {
//     setIsNavOpen(!isNavOpen);
//   };

//   const handleNavItemClick = () => {
//     setIsNavOpen(false);
//   };

//   return (
//     <header>
//       {/* Header Top */}
//    <div className="header-top bgg-darkk pt-md-2">
//   <div className="container">
//     <div className="row justify-content-center justify-content-xl-between align-items-center">
//       <div className="col-auto">
//         <div className="header-top-contact">
//           <ul className="anchor d-md-flex align-items-center">
            
//             {/* Phone */}
//             <li className="px-md-5 fw-bold">
//               <a className="text-white" href="tel:+919136271336">
//                 <i className="fas fa-phone-volume text-white"></i> +91 9136271336
//               </a>
//             </li>

//             {/* Email */}
//             <li className="px-md-5">
//               <a className="text-white" href="mailto:booking@velocitycabs.com">
//                 <i className="far fa-envelope text-white"></i>
//                 <span className="text-white fw-bold"> booking@velocitycabs.com</span>
//               </a>
//             </li>

//             {/* Social Media */}
//             <li className="px-md-3">
//               <a href="https://facebook.com/velocitycab" target="_blank" rel="noopener noreferrer" className="text-white me-3">
//                 <i className="fab fa-facebook-f"></i>
//               </a>

//               <a href="https://www.instagram.com/velocity__cab/" target="_blank" rel="noopener noreferrer" className="text-white me-3">
//                 <i className="fab fa-instagram"></i>
//               </a>

//               <a href="https://x.com/velocitycab" target="_blank" rel="noopener noreferrer" className="text-white me-3">
//                 <i className="fab fa-twitter"></i>
//               </a>

//                <a href="https://in.pinterest.com/velocitycab/" target="_blank" rel="noopener noreferrer" className="text-white">
//     <i className="fab fa-pinterest-p"></i>
//   </a>
//             </li>

//           </ul>
//         </div>
//       </div>
//     </div>
//   </div>
// </div>
//       {/* Main Navigation */}
//       <div className="main-navigation">
//         <Navbar expand="lg">
//           <Container>
//             <img src="/images/logo.jpg" className="logoo" alt="logo" />
//             <Navbar.Toggle aria-controls="main_nav" onClick={toggleNav}>
//               <i className="fas fa-bars darkcolorr"></i>
//             </Navbar.Toggle>

//             <Navbar.Collapse id="main_nav" className={isNavOpen ? "show" : ""}>
//               <Nav className="mx-auto">
//                 <li className="nav-item">
//                   <Link className="nav-link active fw-bold" to="/" onClick={handleNavItemClick}>Home</Link>
//                 </li>
//                 <NavDropdown title="About Us" id="about-us-dropdown" className="fw-bold">
//                   <li className="nav-item">
//                     <Link className="dropdown-item fw-bold" to="/about-us" onClick={handleNavItemClick}>About Us</Link>
//                   </li>
//                   <li className="nav-item">
//                     <Link className="dropdown-item fw-bold" to="/term-condition" onClick={handleNavItemClick}>Term & Condition</Link>
//                   </li>
//                   <li className="nav-item">
//                     <Link className="dropdown-item fw-bold" to="/privacy-policy" onClick={handleNavItemClick}>Privacy Policy</Link>
//                   </li>
//                 </NavDropdown>
//                 <li className="nav-item">
//                   <Link className="nav-link active fw-bold" to="/services" onClick={handleNavItemClick}>Services</Link>
//                 </li>
//                 <li className="nav-item">
//                   <Link className="nav-link active fw-bold" to="/our-fleet" onClick={handleNavItemClick}>Our Fleet</Link>
//                 </li>
//                 <li className="nav-item">
//                   <Link className="nav-link active fw-bold" to="/packages" onClick={handleNavItemClick}>Packages</Link>
//                 </li>


//  <NavDropdown title="Pune ⇌ Mumbai Cab" id="about-us-dropdown" className="fw-bold">
                
//                   <li className="nav-item">
//                     <Link className="dropdown-item fw-bold" to="/pune-mumbai-cabs" onClick={handleNavItemClick}>Pune Mumbai Daily Cab</Link>
//                   </li>
//                   <li className="nav-item">
//                     <Link className="dropdown-item fw-bold" to="/Mumbai-Outstation-Cab" onClick={handleNavItemClick}>Mumbai Outstation Cabs</Link>
//                   </li>
                  //  {/* <li className="nav-item">
                  //   <Link className="dropdown-item fw-bold" to="/Mumbai-Darshan-Cab" onClick={handleNavItemClick}>Mumbai Darshan Cab</Link>
                  // </li> */}
                  // <li className="nav-item">
                  //   <Link className="dropdown-item fw-bold" to="/Mumbai-Airport-Cab-Service" onClick={handleNavItemClick}>Mumbai Airport Cab Service</Link>
                  // </li>
//                 </NavDropdown>

//                   {/* <li className="nav-item">
//                   <Link className="nav-link active fw-bold" to="/packages" onClick={handleNavItemClick}>Pune ⇌ Mumbai Cab</Link>
//                 </li> */}
//                 <li className="nav-item">
//                   <Link className="nav-link active fw-bold" to="/booking" onClick={handleNavItemClick}>Online Booking</Link>
//                 </li>
//                 <li className="nav-item">
//                   <Link className="nav-link active fw-bold" to="/gallery" onClick={handleNavItemClick}>Gallery</Link>
//                 </li>
//                 <NavDropdown title="Contact Us" id="contact-dropdown" className="fw-bold">
//                   <li className="nav-item">
//                     <Link className="dropdown-item fw-bold" to="/contact-us" onClick={handleNavItemClick}>Contact Us</Link>
//                   </li>
//                   <li className="nav-item">
//                     <Link className="dropdown-item fw-bold" to="/enquiry" onClick={handleNavItemClick}>Enquiry</Link>
//                   </li>
//                 </NavDropdown>
//               </Nav>
//             </Navbar.Collapse>
//           </Container>
//         </Navbar>
//       </div>

//       {/* Search Area */}
//       {isSearchOpen && (
//         <div className="search-area">
//           <form action="#">
//             <div className="form-group">
//               <input type="text" className="form-control" placeholder="Type Keyword..." />
//               <button type="submit" className="search-icon-btn">
//                 <i className="far fa-search"></i>
//               </button>
//             </div>
//           </form>
//         </div>
//       )}
//     </header>
//   );
// };

// export default Header;



import React, { useState, useEffect } from "react";
import { Navbar, Nav, NavDropdown, Container } from "react-bootstrap";
import { Link, useLocation } from "react-router-dom";

const Header = () => {
  const [isNavOpen, setIsNavOpen] = useState(false);
  const [isSearchOpen] = useState(false);

  const location = useLocation();

  // ✅ AUTO CLOSE MENU ON ROUTE CHANGE (DESKTOP + MOBILE FIX)
  useEffect(() => {
    setIsNavOpen(false);
  }, [location]);

  return (
    <header>
      {/* HEADER TOP */}
      <div className="header-top bgg-darkk pt-md-2">
        <div className="container">
          <div className="row justify-content-center justify-content-xl-between align-items-center">
            <div className="col-auto">
              <div className="header-top-contact">
                <ul className="anchor d-md-flex align-items-center">

                  <li className="px-md-5 fw-bold">
                    <a className="text-white" href="tel:+919136271336">
                      <i className="fas fa-phone-volume"></i> +91 9136271336
                    </a>
                  </li>

                  <li className="px-md-5">
                    <a className="text-white" href="mailto:booking@velocitycabs.com">
                      <i className="far fa-envelope"></i>
                      <span className="fw-bold"> booking@velocitycabs.com</span>
                    </a>
                  </li>

                  <li className="px-md-3">
                    <a href="https://facebook.com/velocitycab" target="_blank" rel="noreferrer" className="text-white me-3">
                      <i className="fab fa-facebook-f"></i>
                    </a>
                    <a href="https://www.instagram.com/velocity__cab/" target="_blank" rel="noreferrer" className="text-white me-3">
                      <i className="fab fa-instagram"></i>
                    </a>
                    <a href="https://x.com/velocitycab" target="_blank" rel="noreferrer" className="text-white me-3">
                      <i className="fab fa-twitter"></i>
                    </a>
                    <a href="https://in.pinterest.com/velocitycab/" target="_blank" rel="noreferrer" className="text-white">
                      <i className="fab fa-pinterest-p"></i>
                    </a>
                  </li>

                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* MAIN NAVIGATION */}
      <div className="main-navigation">
        <Navbar expand="lg" expanded={isNavOpen} onToggle={setIsNavOpen}>
          <Container>

            {/* LOGO */}
            <img src="/images/logo.jpg" className="logoo" alt="logo" />

            {/* TOGGLE */}
            <Navbar.Toggle aria-controls="main_nav">
              <i className="fas fa-bars darkcolorr"></i>
            </Navbar.Toggle>

            {/* MENU */}
            <Navbar.Collapse id="main_nav">
              <Nav className="mx-auto">

                {/* HOME */}
                <Nav.Link as={Link} to="/" onClick={() => setIsNavOpen(false)} className="fw-bold">
                  Home
                </Nav.Link>

                {/* ABOUT */}
                <NavDropdown title="About Us" id="about-dropdown" className="fw-bold">

                  <NavDropdown.Item as={Link} to="/about-us">
                    About Us
                  </NavDropdown.Item>

                  <NavDropdown.Item as={Link} to="/term-condition">
                    Term & Condition
                  </NavDropdown.Item>

                  <NavDropdown.Item as={Link} to="/privacy-policy">
                    Privacy Policy
                  </NavDropdown.Item>

                </NavDropdown>

                {/* SERVICES */}
                <Nav.Link as={Link} to="/services" onClick={() => setIsNavOpen(false)} className="fw-bold">
                  Services
                </Nav.Link>

                {/* FLEET */}
                <Nav.Link as={Link} to="/our-fleet" onClick={() => setIsNavOpen(false)} className="fw-bold">
                  Our Fleet
                </Nav.Link>

                {/* PACKAGES */}
                <Nav.Link as={Link} to="/packages" onClick={() => setIsNavOpen(false)} className="fw-bold">
                  Packages
                </Nav.Link>

                {/* PUNE MUMBAI */}
                <NavDropdown title="Pune ⇌ Mumbai Cab" id="pune-mumbai-dropdown" className="fw-bold">

                  <NavDropdown.Item as={Link} to="/pune-mumbai-cabs">
                    Pune Mumbai Daily Cab
                  </NavDropdown.Item>

                  <NavDropdown.Item as={Link} to="/Mumbai-Darshan-Cab">
                    Mumbai Darshan Cabs
                  </NavDropdown.Item>
  <NavDropdown.Item as={Link} to="/Mumbai-Outstation-Cab">
                    Mumbai Outstation Cabs
                  </NavDropdown.Item>
<NavDropdown.Item as={Link} to="/Pune-Mumbai-Daily-Cab-Service">
                    Pune to Mumbai Daily Cab
                  </NavDropdown.Item>

  <NavDropdown.Item as={Link} to="/Mumbai-to-Pune-Daily-Cab">
                    Mumbai to Pune Daily Cab
                  </NavDropdown.Item>
                  <NavDropdown.Item as={Link} to="/Mumbai-Airport-Cab-Service">
                    Mumbai Airport Cab Service
                  </NavDropdown.Item>

                </NavDropdown>

                {/* BOOKING */}
                <Nav.Link as={Link} to="/booking" onClick={() => setIsNavOpen(false)} className="fw-bold">
                  Online Booking
                </Nav.Link>

                {/* GALLERY */}
                <Nav.Link as={Link} to="/gallery" onClick={() => setIsNavOpen(false)} className="fw-bold">
                  Gallery
                </Nav.Link>

                {/* CONTACT */}
                <NavDropdown title="Contact Us" id="contact-dropdown" className="fw-bold">

                  <NavDropdown.Item as={Link} to="/contact-us">
                    Contact Us
                  </NavDropdown.Item>

                  <NavDropdown.Item as={Link} to="/enquiry">
                    Enquiry
                  </NavDropdown.Item>

                </NavDropdown>

              </Nav>
            </Navbar.Collapse>

          </Container>
        </Navbar>
      </div>

      {/* SEARCH */}
      {isSearchOpen && (
        <div className="search-area">
          <form action="#">
            <div className="form-group">
              <input type="text" className="form-control" placeholder="Type Keyword..." />
              <button type="submit" className="search-icon-btn">
                <i className="far fa-search"></i>
              </button>
            </div>
          </form>
        </div>
      )}
    </header>
  );
};

export default Header;